<div
    class="gap-[40px] flex flex-col  shrink-0 justify-start items-center pl-[64px] pr-[64px] pt-[40px]  bg-[#f8fafdff] w-[100%] relative">
 
    <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center" [@pageLoad]="pageLoadState">
    <div class="w-full flex flex-row items-center justify-start">
        <button
            type="button"
            class="inline-flex items-center gap-[8px] h-[40px] px-[12px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
            (click)="goBack()"
            aria-label="Back">
            <svg class="w-[16px] h-[16px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>Back</span>
        </button>
    </div>
    <div class="gap-[50px] flex flex-col w-[100%] shrink-0 justify-start items-start self-stretch grow basis-0">
        <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
            <div class="gap-[16px] flex flex-col shrink-0 justify-start items-center"> <span
                    class="shrink-0 justify-start items-start text-[#111215ff] text-center font-bold font-['archivo'] text-[24px] capitalize leading-[29px]">
                    {{ centerDisplayName }} </span>
                
                    <span *ngIf="!selectedName"
                    class="shrink-0 justify-start items-start text-[#444955ff] text-center font-normal font-['archivo'] text-[20px] leading-[32px]">
                    {{ searchHint }}
                 </span>
                 <span *ngIf="selectedName"
                    class="shrink-0 justify-start items-start text-[#444955ff] text-center font-normal font-['archivo'] text-[20px] leading-[32px]">
                    {{ dobHint }}
                 </span>
                </div>
            <NiAutocomplete class="flex-col shrink-0 justify-center  items-start w-[650px] font-archivo"
            [options]="names"
            [minCharsToOpen]="2"
            [valueField]="'value'"
            [label]="''"
            [placeholder]="animatedPlaceholder || searchPlaceholderText"
            [required]="true"
            [readonly]="false"
            [multiple]="false"
            [group]="false"
            leadingIcon="search_lg"
            [(selected)]="selectedName"
            [optionLabel]="'label'"
            [showSubtextInSelection]="true"
            [showClearButton]=" true"
            leadingIconClass="w-6 h-6 text-[#444955]"
            [clearIcon]="'Close'"
            [showDropdownIcon]="false"
            [loading]="isLoadingUsers"
            clearIconClass="w-4 h-4 text-white"
            inputStyle="background-color: white; border: 2px solid #737780; box-shadow: none; border-radius: 24px; width: 650px; height: 67px; color: #000000; font-size: 20px; font-weight: 400; paragraph-spacing: 16px; "
            (onSelect)="onNameSelect($event)"
            (onInputEvent)="onAutocompleteInput($event)"
            >
     
            </NiAutocomplete>
      
            <div *ngIf="selectedName" class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
                <NiDatePicker
                    class="flex-col shrink-0 justify-center items-start w-[650px] font-archivo"
                    [label]="''"
                    [placeholder]="dobPlaceholderText"
                    [required]="true"
                    [disabled]="false"
                    [(date)]="selectedDate"
                    (dateChange)="onDateChange($event)"
                    [format]="'MM/dd/yyyy'"
                    [maxDate]="maxDate"
                    [defaultViewDate]="defaultDobViewDate"
                    leadingIcon="Calendar"
                    leadingIconClass="w-5 h-5 text-[#444955]"
                    containerStyle="background-color: white; border: 2px solid #737780; box-shadow: none; border-radius: 24px; width: 650px; height: 67px;"
                    inputStyle="padding: 0 24px 0 0; font-size: 20px; font-weight: 500; color: #000000; background-color: transparent; paragraph-spacing: 16px; "
                    [clearIcon]="'Close'"
                    clearIconClass="w-4 h-4 text-white"
                >
                </NiDatePicker>
            </div>
        </div>
        <div *ngIf="!selectedName" class="gap-[16px] flex flex-col w-[100%] shrink-0 justify-center items-center self-stretch">
            <button
                type="button"
                class="gap-[8px] flex flex-row shrink-0 rounded-[16px] justify-start items-center pl-[48px] pr-[48px] pt-[16px] pb-[16px] bg-[#ffffffff] border-[1px]"
                style="background-image: url('assets/icons/Background.svg');"
                (keydown)="handleCardDivKeyDown($event)"
                [attr.aria-label]="'Card check-in area'">
                <img src="assets/icons/card-check-in.gif"
                    alt="Card check-in animation"
                    loading="lazy"
                    decoding="async"
                    class="w-[200px] h-[200px] shrink-0 rounded-[8px] justify-start items-start shadow-[0px_0px_11px_0px_#00000000] mix-blend-darken" />
            </button> <span
                class="shrink-0 justify-start items-start text-[#444955ff] text-center font-normal font-['archivo'] text-[24px] leading-[29px]">
                {{ tapCardText }} </span>
           
        </div>
        <div *ngIf="selectedName " class="flex flex-col items-center justify-center w-full">
            <NiButton 
            [label]="verifyButtonLabel" 
            bg="primary-500"
            text="white"
            hoverBg="primary-600"
            hoverText="white"
            borderColor="primary-500"
            rounded="full"
            px="[24px]"
            py="[20px]"
            w="[350px]"
            fontSize="[24px]"
            fontWeight="bold"
            (click)="onVerify()"
            (keydown)="handleVerifyKeyDown($event)"
            styleClass="relative group overflow-hidden transition-all duration-300 ease-out justify-center items-center font-archivo  line-height-[29px] tracking-[0.5px]"
            >
        </NiButton>
        </div>

      


    </div>
    </div>
    
   
</div>
<NiAlert
*ngIf="toasterMessage"
[isVisible]="true"
[message]="toasterMessage"
[variant]="toasterVariant"
[position]="'top-right'"
[dismissible]="true"
[duration]="4000"
(onClose)="dismissToaster()">
</NiAlert>